import create from "zustand";
import { persist } from "zustand/middleware";

const store = (set) => ({
  rightSideBarSocket: true,
  setRightSideBarSocket: (rightSideBarSocket) => set({ rightSideBarSocket }),
});

const configStore = create(persist(store));

export default configStore;
